import React from 'react'

/* mui */
import Grid from '@material-ui/core/Grid'
/* mui */

const wrapper = props => {
  return (
    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
      {props.children}
    </Grid>
  )
}

export default wrapper
